import React from 'react';
import Tabs from 'react-scale/components/elements/tabs';

import annotationTypes from 'react-scale/components/tailwind/product-examples/examples';
import ExampleContent from 'react-scale/components/tailwind/product-examples/ExampleContent';

import {
  code,
  example,
  response,
  result
} from 'react-scale/components/website/index/Products/examples/general/example-audio';
import scenes from 'react-scale/components/website/big/open-datasets/pandaset/LidarScenes';
import Viewer from '../../3d-sensor-fusion/hero/viewer';

const Training = () => (
  <Tabs
    tabs={[
      {
        title: '3D Task',
        content: (
          <div className="rounded-xl overflow-hidden">
            <Viewer scene={scenes[5]} isInteractive={false} />
          </div>
        )
      },
      {
        title: 'Image',
        content: (
          <div className="xl:h-[420px]">
            <ExampleContent
              code={annotationTypes.image[0].example.code}
              response={annotationTypes.image[0].example.response}
              example={annotationTypes.image[0].example.example}
              result={annotationTypes.image[0].example.result}
              responseDelay={annotationTypes.image[0].responseDelay || 1}
            />
          </div>
        )
      },
      {
        title: 'Video',
        content: (
          <div className="xl:h-[420px]">
            <ExampleContent
              code={annotationTypes.video[0].example.code}
              response={annotationTypes.video[0].example.response}
              example={annotationTypes.video[0].example.example}
              result={annotationTypes.video[0].example.result}
              responseDelay={annotationTypes.video[0].responseDelay || 1}
            />
          </div>
        )
      },
      {
        title: 'Text',
        content: (
          <div className="xl:h-[420px]">
            <ExampleContent
              code={annotationTypes.text[0].example.code}
              response={annotationTypes.text[0].example.response}
              example={annotationTypes.text[0].example.example}
              result={annotationTypes.text[0].example.result}
              responseDelay={annotationTypes.text[0].responseDelay || 1}
            />
          </div>
        )
      },
      {
        title: 'Audio',
        content: (
          <div className="xl:h-[420px]">
            <ExampleContent
              code={code}
              response={response}
              example={example}
              result={result}
              responseDelay={1}
            />
          </div>
        )
      }
    ]}
  />
);

export default Training;
